module.exports = __webpack_public_path__ + "img/accuctp.08d9d3ee.png";